import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitFirmwareModel } from '@apps-common/types/management/unit-firmware'

export const MANAGEMENT_QUERY_KEY_SEARCH_UNIT_FIRMWARES = (search?: string) => ['getUnitFirmwares', search].filter(Boolean)

export const searchUnitFirmwares = async (search?: string): Promise<IUnitFirmwareModel[]> =>
  axios.get(`/management/unitfirmware/SearchUnitFirmware?search=${search || ''}`).then((res) => res.data?.data)

type QueryFnType = typeof searchUnitFirmwares

type Props = {
  config?: QueryConfig<QueryFnType>
  search?: string
}

export const useManagementSearchUnitFirmwares = ({ config, search }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: MANAGEMENT_QUERY_KEY_SEARCH_UNIT_FIRMWARES(search),
    queryFn: () => searchUnitFirmwares(search)
  })
